import { useEffect, useState ,useCallback, useContext  } from "react";
import IndiaDataGrid from "../../include/IndiaDataGrid";
import { Box, Button, Container, MenuItem, Typography, useMediaQuery,Chip, TextField,PaginationItem, Pagination,} from "@mui/material";
import { useGridApiRef, gridPageCountSelector, gridPageSelector, useGridSelector } from "@mui/x-data-grid";
import { CheckCircleOutline, InfoOutline, LocalOffer, PrintOutlined, Verified } from "@mui/icons-material";

import GradientLoader from "../CommanComponents/GradientLoader";
import { useNavigate } from "react-router-dom";
import { callPostApi } from "../../function/ApiCallFunction";
import { DataContext } from "../../context/DataContext";

// ---------- Custom Pagination Component ----------
function CustomPagination({ apiRef, isMobile }) 
{
  const page      = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  const handlePageChange = (_, value) => 
  {
    apiRef.current.setPage(value - 1);
    if (isMobile && apiRef.current) {
      setTimeout(() => {
        apiRef.current.autosizeColumns({ includeHeaders: true });
      }, 0); } };
    return (
    <Pagination color="primary" variant="outlined" shape="rounded" page={page + 1} count={pageCount}
      renderItem={(props2) => <PaginationItem {...props2} disableRipple />} onChange={handlePageChange} />
  ); 
}

export function ActivatedQR() 
{
  const apiRef   = useGridApiRef();
  const isMobile = useMediaQuery("(max-width:768px)");
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [datar,   setDatar]   = useState([]);
  const [paginationModel, setPaginationModel] = useState({ pageSize: 10, page: 0, });
  
  const {loginData } = useContext(DataContext);
  const store_id = loginData?.store_info?.store_id;

  // Filters
  const [filterLimit,    setFilterLimit]    = useState(100);  
  const [filterStatus,   setFilterStatus]   = useState('Activated');
  const [filterLotNo,    setFilterLotNo]    = useState('');
  const [filterLoadedNo, setFilterLoadedNo] = useState('');
  const fetchLimits    = [ "5", "10", "20", "50", "100", "250", "500", "1000"];

  // ---------- API Call ----------
  const QRListApi = useCallback(async (status = filterStatus, genLotNumber = filterLotNo, loadingNumber = filterLoadedNo, limit = filterLimit) =>
  {
      try 
      {
          setLoading(true);
          const payload = { mod: "CASHI_QECODE_LIST", data_arr: { store_id, genLotNumber, loadingNumber,qrcodeStatus:'2', start: '0', limit, }, };
          const apiResult = await callPostApi("cashi-qrcode", payload);
          if (apiResult.status === "200" && Array.isArray(apiResult.data)) 
          {
              const formattedData = apiResult.data.filter((item) => item.redeem_status === "0").map((item, index) => ({
                id         :item.id,
                sr         : index + 1,
                lotno      : item.gen_lot_number || "NA",
                qr         : item.qrcode_number || "NA",
                expdate    : item.active_date || "NA",
                amount     : item.amount || "0",
                loadedno   : item.loading_number || "0",
                statusname : item.qrcode_status_name || "NA",
                status     : item.qrcode_status === "0" ? "Pending" : item.qrcode_status === "2" ? "Activated" : item.qrcode_status === "1" ? "Loaded" : "NA"
              }));
             setDatar(formattedData);              
          } 
          else { setDatar([]); }
      } 
      catch (err) {setDatar([]); } 
      finally { setLoading(false); }

  },[store_id, filterStatus, filterLotNo, filterLoadedNo, filterLimit]); 
  
  // ---------- Clear Filters ----------
  const clearFun = async () => 
  {
      setFilterStatus("Activated");
      setFilterLotNo("");
      setFilterLoadedNo("");
      setFilterLimit(100);
      setPaginationModel({ ...paginationModel, page: 0 });
      await QRListApi("Activated", "", "", 100);
  }
  
  // ---------- Initial Load ----------
  useEffect(() => { QRListApi(); }, [QRListApi]);


  const columns = [
    { field: 'sr',     headerName: 'Sr no.', flex:isMobile ? undefined : 0.5},
    { field: 'qr',     headerName: 'QR',     flex:isMobile ? undefined : 1,},
    { field: 'amount', headerName: 'Amount', flex:isMobile ? undefined : 1 },
    { field: 'status', headerName: 'Status', flex:isMobile ? undefined : 1,
      renderCell: (params) => {
         let color = "default";
        let icon = null;
        let border = "default";
  
        switch (params.value) {
          case "Activated":
            color = "#098665";
            border= '1px solid #098665';
            icon = <Verified sx={{ fontSize: 18 }} />;
            break;
          case "Pending":
            color = "#e9aa0aff";
            border= '1px solid #e9aa0aff';
            icon = <InfoOutline sx={{ fontSize: 18 }} />;
            break;
          case "Loaded":
            color = "#0a32d4ff";
            border= '1px solid #0a32d4ff';
            icon = <CheckCircleOutline sx={{ fontSize: 18 }} />;
            break;
          default:
            color = "default";
        }
          return (
          <Chip  icon={icon} label={params.value || "Unknown"} variant="outlined" color={color}
            sx={{ borderRadius: "18px", fontWeight: 500, border:{border}, color:{color} }} />
      ); } },
    { field: 'lotno', headerName: 'Lot Number', flex:isMobile ? undefined :  1 },
    { field: 'loadedno', headerName: 'Loading Number', flex:isMobile ? undefined :  1 },
    { field: 'expdate', headerName: 'Date', flex:isMobile ? undefined : 1 },
   ]

   

  return (
    <Container maxWidth="xl" sx={{ my: 2 }}>
        
      <Box sx={{ display: "flex", justifyContent: "start", mb: 2 }}>
        <Button  variant="contained"  sx={{ backgroundColor: "#000000", color: "#ffffff" }} onClick={() => navigate(-1)}> Back </Button>
      </Box>

      <Typography ariant="h6"  gutterBottom sx={{ background: "linear-gradient(195deg, #49a3f1, #1A73E8)",  p: 1, color: "#ffffff",
          borderRadius: "4px", mb: 3, display: "flex", alignItems: "center",}} > <LocalOffer sx={{ mr: 1 }} /> Activated QR
      </Typography>

      <Box sx={{ display: 'flex', justifyContent: 'end', mb: 2 }}>
        <Button variant="contained"  sx={{ background:'linear-gradient(195deg, #42424a, #191919)', color: '#ffffff'}} 
          onClick={() => navigate('/dashboardPlus/printQR')} > <PrintOutlined sx={{mx:1}}/> Print QR </Button>
      </Box>

      <Box sx={{ display: 'flex',flexWrap:'wrap', gap: 2, mb: 2 }}>
        <TextField select label="Filter Status" value={filterStatus} onChange={e => { setFilterStatus(e.target.value); }} sx={{ minWidth: 140 }}>
          <MenuItem value="Activated">Activated</MenuItem>
       </TextField>
        <TextField  type='text' label="Lot Number"     value={filterLotNo}    onChange={e => setFilterLotNo(e.target.value)}   sx={{ minWidth: 140 }} > </TextField>
        <TextField  type='text' label="Loading Number" value={filterLoadedNo} onChange={e => setFilterLoadedNo(e.target.value)} sx={{ minWidth: 140 }} > </TextField>

        <TextField select label="Limit" value={filterLimit} onChange={e => setFilterLimit(e.target.value)} sx={{ minWidth: 140 }} >       
              {fetchLimits.map(value => ( <MenuItem value={value}>{value}</MenuItem>))}
        </TextField>

         <Button variant="outlined" color="primary" sx={{ height: 56 }} onClick={() => { QRListApi();  }}> Apply Filter </Button>
         <Button variant="outlined" color="error" sx={{ height: 56 }} onClick={() => { clearFun() }} > Clear Filter </Button>
      </Box>

        {/* DataGrid */}
        <Box sx={{ height: "auto", width: "100%", mb: 4 }}>
          <IndiaDataGrid apiRef={apiRef} rows={datar} columns={columns} showToolbar checkboxSelection 
          slots={{ pagination: () => <CustomPagination apiRef={apiRef} isMobile={isMobile} />}}
          paginationModel={paginationModel}  onPaginationModelChange={setPaginationModel}
          getRowHeight={() => "auto"}
            sx={{
              "& .MuiDataGrid-cell": {whiteSpace: "normal",wordBreak: "break-word",display: "flex",alignItems: "center",gap: "4px",},
              "& .MuiDataGrid-columnHeaders": {backgroundColor: "#f0f0f0",color: "#000",fontWeight: "bold",},
              "& .MuiDataGrid-columnHeaderTitle": {fontSize: 14,fontWeight: 600,whiteSpace: "normal",wordBreak: "break-word",},
            }}
          />
        </Box>

        {/* Add Campaign Dialog */}
        {loading && <GradientLoader text="Loading" />}   {/* Loader */}

    </Container>
  );
}
